export default () => {

	const swatchesWrappers = document.querySelectorAll('.js-color-swatches');
	if (!swatchesWrappers.length) return;

	swatchesWrappers.forEach(wrapper => {

		const swatches = wrapper.querySelectorAll('.js-color-swatch');
		const colorText = wrapper.querySelector('.js-color-name');

		swatches.forEach(swatch => {
			swatch.addEventListener('mouseenter', () => {
				const color = swatch.getAttribute('data-color-name');
				colorText.innerHTML = `${color}`;
			});

			swatch.addEventListener('mouseleave', () => {
				const color = colorText.getAttribute('data-default-color');
				colorText.innerHTML = `${color}`;
			});
		});

	});

}
